import { Button, FormControl, FormHelperText } from '@mui/material';

const ImageInput = ({ formik, label, name }) => {
    const handleFileChange = (event) => {
        const file = event.currentTarget.files[0];
        formik.setFieldValue(name, file);
    };

    return (
        <FormControl fullWidth>
            <Button
                variant="outlined"
                component="label"
                fullWidth
                sx={{
                    paddingY: "12px",
                    "& .MuiButton-label": {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }
                }}
            >
                Upload {label}
                <input
                    id={name}
                    name={name}
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleFileChange}
                    onBlur={formik.handleBlur}
                />
            </Button>
            <FormHelperText error={formik.touched[name] && !!formik.errors[name]}>
                {formik.touched[name] && formik.errors[name]
                    ? formik.errors[name]
                    : "Upload an image file."}
            </FormHelperText>
        </FormControl>
    );
};

export default ImageInput;
